import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
   selector: "app-register-bar",
   templateUrl: "./register-bar.component.html",
   styleUrls: ["./register-bar.component.scss"],
})
export class RegisterBarComponent implements OnInit{
   showRegisterBar = true;
   currentLanguage: string;

   constructor(private translate: TranslateService) {}

   ngOnInit(): void {
      this.currentLanguage = this.translate.currentLang;
   }

   closeThisBar() {
      this.showRegisterBar = false;
   }
}
